import { Auth0Provider, withAuthenticationRequired } from "@auth0/auth0-react";
import { CircularProgress, Stack, Typography } from "@mui/material";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Home from "./pages/Home";
import PlayerDashboard from "./pages/PlayerDashboard";
import "./index.scss";
import ResponsiveShell from "./layout/ResponsiveShell";
// import reportWebVitals from "./reportWebVitals";
import Leagues from "./pages/Leagues";
import League from "./pages/League";
import Profile from "./pages/Profile";
import JoinLeague from "./components/joinleague/JoinLeague";
import Callback from "./components/callback/Callback";
import { AvatarCacheProvider } from "./contexts/AvatarCacheContext";

// Wrapper to provide onRedirectCallback with useNavigate
function Auth0ProviderWithRedirect({
  children,
}: {
  children: React.ReactNode;
}) {
  const navigate = useNavigate();
  const onRedirectCallback = (appState: any) => {
    navigate(appState?.returnTo || "/", { replace: true });
  };
  return (
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN!}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID!}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/callback`,
        scope: "openid profile email offline_access",
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
}

const AuthRedirecting = () => (
  <Stack minHeight="60vh" alignItems="center" justifyContent="center" spacing={2}>
    <CircularProgress aria-label="Checking your session" />
    <Typography color="text.secondary">Checking your session...</Typography>
  </Stack>
);
const protectedRouteOptions = { onRedirecting: AuthRedirecting };
const ProtectedDashboard = withAuthenticationRequired(PlayerDashboard, protectedRouteOptions);
const ProtectedLeagues = withAuthenticationRequired(Leagues, protectedRouteOptions);
const ProtectedLeague = withAuthenticationRequired(League, protectedRouteOptions);
const ProtectedProfile = withAuthenticationRequired(Profile, protectedRouteOptions);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <Auth0ProviderWithRedirect>
        <AvatarCacheProvider>
          <ResponsiveShell>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/dashboard" element={<ProtectedDashboard />} />
                <Route path="/callback" element={<Callback />} />
                <Route path="/leagues" element={<ProtectedLeagues />} />
                <Route path="/leagues/:id" element={<ProtectedLeague />} />
                <Route path="/profile" element={<ProtectedProfile />} />
                <Route path="/join" element={<JoinLeague />} />
              </Routes>
          </ResponsiveShell>
        </AvatarCacheProvider>
      </Auth0ProviderWithRedirect>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
